export const retentionFields = [
    { label: 'PM files - storage limit per device', key: 'PM_MAX_SIZE', unit: 'MB ' },
    { label: 'CM files - storage limit', key: 'CM_MAX_SIZE', unit: 'MB' },
    { label: 'CPER files - storage limit per device', key: 'CPER_MAX_SIZE', unit: 'MB ' },
    { label: 'Debug Logs files - storage limit per device', key: 'DEBUGLOGS_MAX_SIZE', unit: 'MB ' },
    { label: 'Error bundles files - storage limit per device', key: 'COREFILE_MAX_SIZE', unit: 'MB ' },
    { label: 'Device database backup files - storage limit  per device', key: 'SN_DB_MAX_SIZE', unit: 'MB ' },
    { label: 'AMS database backup - storage limit', key: 'DB_BACKUP_MAX_SIZE', unit: 'MB' },
  ];